import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';
import axiosChargeCategory from 'app/api/apiChargeCategory';
import PaginationModel from 'app/utils/PaginationApiModel';

export const getChargeCategories = createAsyncThunk('commonAPI/chargeCategory/getChargeCategories', async () => {
   const params = PaginationModel.PageSize9999ApiModel();
   const response = await axiosChargeCategory.apiChargeCategory.list({ ...params });
   const data = await response.data;

   return data === undefined ? null : data;
});

const chargeCategoryCommonDataAdapter = createEntityAdapter({
   selectId: (category) => category.iId,
});

export const { selectAll: selectChargeCategoriesCommon } = chargeCategoryCommonDataAdapter.getSelectors(
   (state) => state.commonAPI.chargeCategories.dataChargeCategories
);

const chargeCategoryCommonSlice = createSlice({
   name: 'chargeCategories',
   initialState: {
      dataChargeCategories: chargeCategoryCommonDataAdapter.getInitialState(),
   },
   reducers: {
      setLoading: {
         reducer: (state, action) => {
            state.loading = action.payload;
         },
      },
   },
   extraReducers: {
      [getChargeCategories.fulfilled](state, { payload }) {
         chargeCategoryCommonDataAdapter.setAll(state.dataChargeCategories, payload);
      },
   },
});

export const { setLoading } = chargeCategoryCommonSlice.actions;

export default chargeCategoryCommonSlice.reducer;
